var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorAnnotation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Color selection") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color-selection",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(2.000000, 2.000000)",
    id: "Path",
    stroke: "#BABABA",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25800002,14.4180001 L1.51600001,10.676 C0.689000003,9.84900004 0.689000003,8.50900004 1.51600001,7.68200003 L7.15000003,2.04800001 L13.8860001,8.78400004 L8.25200003,14.4180001 C7.42500003,15.2440001 6.08400003,15.2440001 5.25800002,14.4180001 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8830001,11.774 C16.8830001,11.774 14.7660001,14.0710001 14.7660001,15.4790001 C14.7660001,16.6430001 15.7190001,17.5960001 16.8830001,17.5960001 C18.0470001,17.5960001 19.0000001,16.6430001 19.0000001,15.4780001 C19.0000001,14.0710001 16.8830001,11.774 16.8830001,11.774 L16.8830001,11.774 Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.15000003,
    y1: 2.05000001,
    x2: 6.06000003,
    y2: 0.940000004
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.8900001,
    y1: 8.78000004,
    x2: 0.930000004,
    y2: 8.78000004
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.42000001,
    y1: 19.4400001,
    x2: 10,
    y2: 19.4400001
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24.0000001 0 24.0000001 24.0000001 0 24.0000001"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorAnnotation);
export default __webpack_public_path__ + "static/media/ColorAnnotation.7f12326e3a19660c341f81e1ca2ab0c6.svg";
export { ForwardRef as ReactComponent };